import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, Popper, Paper, List, ListItemButton } from '@mui/material';
import { useDebounce } from '../../hooks/useDebounce';
import { searchOrgUsers } from '../../api/ticketApi';

const DEBOUNCE_MS = 300;
const MIN_SEARCH_LEN = 2;

export default function AddWatcherInput({ ticketId, onAdded }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const anchorRef = useRef(null);
  const debouncedQuery = useDebounce(query, DEBOUNCE_MS);

  useEffect(() => {
    if (debouncedQuery.length < MIN_SEARCH_LEN) {
      setResults([]);
      setOpen(false);
      return;
    }
    setLoading(true);
    searchOrgUsers(debouncedQuery)
      .then((list) => {
        setResults(Array.isArray(list) ? list : []);
        setOpen(true);
      })
      .catch(() => {
        setResults([]);
        setOpen(false);
      })
      .finally(() => setLoading(false));
  }, [debouncedQuery]);

  const handleSelect = (user) => {
    setOpen(false);
    setQuery('');
    setResults([]);
    onAdded?.(user);
  };

  return (
    <Box ref={anchorRef}>
      <TextField
        size="small"
        placeholder="Search users by name or email"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        aria-label="Add watcher"
        aria-expanded={open}
        sx={{ minWidth: 280 }}
      />
      <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" sx={{ zIndex: 1300 }}>
        <Paper elevation={2} sx={{ maxHeight: 300, overflow: 'auto', minWidth: 280 }}>
          {loading ? (
            <List><ListItemButton disabled>Loading...</ListItemButton></List>
          ) : results.length === 0 ? (
            <List><ListItemButton disabled>No users found</ListItemButton></List>
          ) : (
            <List>
              {results.map((u) => (
                <ListItemButton
                  key={u.userId}
                  onClick={() => handleSelect(u)}
                  role="option"
                >
                  {u.userName || u.userEmail || u.userId}
                </ListItemButton>
              ))}
            </List>
          )}
        </Paper>
      </Popper>
    </Box>
  );
}
